<template>
  <div @click.stop="">
    <template v-if="event">

      <v-menu offset-y :close-on-content-click="true" :nudge-width="100" v-model="todo_menu" v-if="is_past && is_todo_list">
        <!--<v-btn slot="activator" dark small color="deep-orange" flat fab><v-icon>live_tv</v-icon></v-btn>-->
        <slot slot="activator" name="on" v-if="is_todo_list"></slot>
        <slot slot="activator" name="off" v-if="!is_todo_list"></slot>
        <v-list dense>
          <v-list-tile @click="set_status_ready"><v-list-tile-title>Ready</v-list-tile-title></v-list-tile>
          <v-list-tile @click="toggle_todo"><v-list-tile-title>
            <span v-if="is_todo_list">Remove from todo list</span>
            <span v-if="!is_todo_list">Todo</span>
          </v-list-tile-title></v-list-tile>
        </v-list>
      </v-menu>

      <div v-if="is_past && !is_todo_list" @click.stop="toggle_todo">
        <slot name="on" v-if="is_todo_list"></slot>
        <slot name="off" v-if="!is_todo_list"></slot>
      </div>


      <div v-if="!is_past" @click.stop="toggle_todo">
        <slot name="on" v-if="is_todo_list"></slot>
        <slot name="off" v-if="!is_todo_list"></slot>
      </div>
  </template>
  </div>
</template>

<script>
import Vue from 'vue'
import datelib from '@/lib/date.js';
import EventModel from '@/models/event.js'

export default {
  props: ['uuid'],
  data() {
    var ch = this.$cloudserver.channel("events:"+this.uuid);
    return {
      ws_channel: ch,
      event: _.cloneDeep(ch.data),
      timestamp: 0,
      updater: undefined,
      todo_menu: false,
      is_past: false,
      is_todo_list: false
    };
  },
  watch: {
    "ws_channel.data": {
      handler(val) {
        this.event = _.cloneDeep(val);
        this.timestamp_update();
      },
      deep: true
    }
  },
  created() {
    this.ws_channel.join();
  },
  mounted () {
    var self = this;
    this.timestamp = self.$store.state.timestamp;
    this.timestamp_update();
    this.updater = setInterval(function() {
      self.timestamp = self.$store.state.timestamp;
      self.timestamp_update();
    },1000);
  },
  computed: {
    is_todo() {
      if (typeof(this.event) != "undefined") {
        if (typeof(this.event.event_group) != "undefined") {
          return EventModel.is_todo_list(this.event, this.$store.state.account);
        }
      }
      return false;
    }
  },
  methods: {
    timestamp_update() {
      if (typeof(this.event) != "undefined") {
        this.is_past = EventModel.is_past(this.event, this.timestamp);
        this.is_todo_list = EventModel.is_todo_list(this.event, this.$store.state.account);
      }
    },
    set_status_ready() {
      var self = this;
      this.ws_channel.push("toggle_todo", {active: true, status: "ready"})
        .receive("ok", (msg) => {
          self.ws_channel.setData(msg);
          self.$message.success("Event was updated!");
        })
        .receive("error", (msg) => {
          self.$message.success("Unable to update event!");
        });
    },
    toggle_todo() {
      var self = this;
      this.ws_channel.push("toggle_todo", {status: "watch"})
        .receive("ok", (msg) => {
          self.ws_channel.setData(msg);
          self.$message.success("Event was updated!");
        })
        .receive("error", (msg) => {
          self.$message.success("Unable to update event!");
        });
    }
  }
}
</script>
